function defaultDueDate() {
  const d = new Date();
  d.setDate(d.getDate() + 30);
  return d.toISOString().slice(0, 10);
}

/** The draft the onboarding wizard starts from; the wizard owns the state. */
export function defaultTaskDraft(session) {
  return {
    title: 'Confirm reference check process is in place for all joiners',
    description:
      'Review how reference checks are currently handled. Upload a sample completed reference check (redacted if needed) as evidence, or document the process used.',
    assigneeId: session.userId,
    dueDate: defaultDueDate(),
  };
}

/**
 * Controlled step body. The write runs in the wizard's `validate()`; once it
 * has run, `created` locks the fields so the action is never created twice.
 */
export default function TaskCreateStep({ value, onChange, users, created }) {
  const set = (patch) => onChange({ ...value, ...patch });

  return (
    <div>
      <h2
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: 'var(--fg)',
          marginBottom: 8,
          fontFamily: 'var(--font-display)',
        }}
      >
        Let's do something about it
      </h2>
      <p style={{ fontSize: 14, color: 'var(--fg2)', lineHeight: 1.65, marginBottom: 20 }}>
        A risk on its own doesn't fix anything. The way to reduce it is to take action — and track
        that you actually did it. Let's create a task: someone in your team should confirm that
        reference checks are being done, and attach evidence.
        {created && ' Saved — it is now in your task list.'}
      </p>

      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Title</label>
        <input
          value={value.title}
          onChange={(e) => set({ title: e.target.value })}
          disabled={created}
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Description</label>
        <textarea
          value={value.description}
          onChange={(e) => set({ description: e.target.value })}
          disabled={created}
          rows={4}
          style={{ ...inputStyle, resize: 'vertical' }}
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 0 }}>
        <div>
          <label style={labelStyle}>Assignee</label>
          <select
            value={value.assigneeId}
            onChange={(e) => set({ assigneeId: e.target.value })}
            disabled={created}
            style={{ ...inputStyle, cursor: 'pointer' }}
          >
            {(users || []).map((u) => (
              <option key={u.id} value={u.id}>
                {u.displayName || u.username}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Due date</label>
          <input
            type="date"
            value={value.dueDate}
            onChange={(e) => set({ dueDate: e.target.value })}
            disabled={created}
            style={{ ...inputStyle, cursor: 'pointer' }}
          />
        </div>
      </div>
    </div>
  );
}

const labelStyle = {
  display: 'block',
  marginBottom: 6,
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
  color: 'var(--fg3)',
  fontFamily: 'var(--font-mono)',
};

const inputStyle = {
  width: '100%',
  background: 'var(--bg3)',
  border: '1px solid var(--border2)',
  borderRadius: 8,
  padding: '10px 12px',
  color: 'var(--fg)',
  fontSize: 13,
  fontFamily: 'var(--font-body)',
  lineHeight: 1.5,
  outline: 'none',
};
